import env from '@framework/env/env';

export const sharedConfig = {
  dealvdr: {
    code: 'dealvdr' as const,
    name: 'DealVDR',
    abbr: 'VDR',
    hostname: env('DEALVDR_DOMAIN'),
    supportEmail: env('CREDENTIALS__TENANT_DEALVDR__SUPPORT__EMAIL'),
    salesEmail: env('CREDENTIALS__TENANT_DEALVDR__SUPPORT__SALES_EMAIL'),
    supportPhoneNumber: env('CREDENTIALS__TENANT_DEALVDR__SUPPORT__PHONE'),
    supportChatId: env('FRONT_APP__CHAT_ID_TENANT_DEALVDR'),
    conferencePhoneNumber: env('CREDENTIALS__TENANT_DEALVDR__SUPPORT__CONFERENCE_PHONE'),
    api: {
      internal: env('TENANT_DEALVDR_WS__HOSTNAME_INTERNAL'),
    },
    ga: {
      trackingId: env('GA__TRACKING_ID_TENANT_DEALVDR'),
    },
    gtm: {
      trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_DEALVDR__GTM_ID'),
    },
    featureToggle: {
      diligenceChecklistEnabled: { cookieName: 'diligenceChecklistEnabled' },
      askMeEnabled: { cookieName: 'askMeEnabled' },
      documentTranslationEnabled: { cookieName: 'documentTranslationEnabled' },
      ocrEnabled: { cookieName: 'ocrEnabled' },
      videoPlayerEnabled: { cookieName: 'videoPlayerEnabled' },
    },
    options: {
      isDataroom: true,
      tenantPathName: 'dataroom',
      isCountryOfBusinessEnabled: false,
      isGeneralAppDisclaimerEnabled: false,
      defaultPhoneCountry: 'us',
      tenantUrlPrefix: env('TENANT_DEALVDR___DATAROOM__PREFIX_URL'),
      tenantLabelLg: 'DealVDR',
      tenantLabel: 'Data Room',
      tenantLabelSm: 'data room',
      label: 'Data Room',
      isDocumentationStateEnabled: false,
      isStagingModuleAvailable: true,
      isDocumentTranslationEnabled: true,
      isFileStorageRegionSelectEnabled: true,
      isStagesEnabled: false,
      isInitialTimeZoneEnabled: false,
      isInvestorPermissions: false,
      isRestrictionByCountryEnabled: false,
      isVisibilityControlEnabled: false,
      isEnhancedTaggingSectionRequired: false,
      isTransactionTypeEnabled: true,
      isPublicListingOptionEnabled: false,
      isHelpSiteEnabled: true,
      isAnalyticsViewTimeEnabled: true,
      isManageAccessRequestsEnabled: false,
      tenantLabelPlural: 'Data Rooms',
      tenantSettingsPrefix: 'data-room-settings',
      visibleSectorForTransactionTypeList: [
        '900c29f7-5068-45a9-a136-c392101b9b84', // SECURITIZATION
        '20478fc8-107d-4e1f-bf74-095c4ae26179', // OTHER
      ],
    },
    isConsentForEDeliveryRequired: false,
    isSectorAlwaysVisible: false,
  },
  loansend: {
    code: 'loansend' as const,
    name: 'LoanSend',
    abbr: 'LS',
    hostname: env('LOANSEND_DOMAIN'),
    supportEmail: env('CREDENTIALS__TENANT_LOANSEND__SUPPORT__EMAIL'),
    salesEmail: env('CREDENTIALS__TENANT_LOANSEND__SUPPORT__SALES_EMAIL'),
    supportPhoneNumber: env('CREDENTIALS__TENANT_LOANSEND__SUPPORT__PHONE'),
    supportChatId: env('FRONT_APP__CHAT_ID_TENANT_LOANSEND'),
    conferencePhoneNumber: env('CREDENTIALS__TENANT_LOANSEND__SUPPORT__CONFERENCE_PHONE'),
    api: {
      internal: env('TENANT_LOANSEND_WS__HOSTNAME_INTERNAL'),
    },
    ga: {
      trackingId: env('GA__TRACKING_ID_TENANT_LOANSEND'),
    },
    gtm: {
      trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_LOANSEND__GTM_ID'),
    },
    featureToggle: {
      diligenceChecklistEnabled: { cookieName: 'diligenceChecklistEnabled' },
      documentTranslationEnabled: { cookieName: 'documentTranslationEnabled' },
      askMeEnabled: { cookieName: 'askMeEnabled' },
      ocrEnabled: { cookieName: 'ocrEnabled' },
      videoPlayerEnabled: { cookieName: 'videoPlayerEnabled' },
    },
    options: {
      isDataroom: true,
      tenantPathName: 'loansend',
      isCountryOfBusinessEnabled: false,
      isGeneralAppDisclaimerEnabled: false,
      defaultPhoneCountry: 'us',
      isAnalyticsViewTimeEnabled: true,
      isVisibilityControlEnabled: true,
      tenantUrlPrefix: env('TENANT_LOANSEND___DATAROOM__PREFIX_URL'),
      tenantLabelLg: 'LoanSend',
      tenantLabel: 'LoanSend',
      tenantLabelSm: 'loansend',
      label: 'LoanSend',
      isDocumentationStateEnabled: false,
      isStagingModuleAvailable: true,
      isDocumentTranslationEnabled: true,
      isFileStorageRegionSelectEnabled: true,
      isStagesEnabled: false,
      isInitialTimeZoneEnabled: false,
      isInvestorPermissions: false,
      isRestrictionByCountryEnabled: false,
      isEnhancedTaggingSectionRequired: false,
      isTransactionTypeEnabled: true,
      isPublicListingOptionEnabled: false,
      isHelpSiteEnabled: true,
      isManageAccessRequestsEnabled: false,
      tenantLabelPlural: 'LoanSends',
      tenantSettingsPrefix: 'data-room-settings',
      visibleSectorForTransactionTypeList: [],
    },
    isConsentForEDeliveryRequired: false,
    isSectorAlwaysVisible: false,
  },
  '17g5': {
    code: '17g5' as const,
    name: '17g5.com',
    abbr: '17G',
    hostname: env('SEVENTEENG5_DOMAIN'),
    supportEmail: env('CREDENTIALS__TENANT_17G5__SUPPORT__EMAIL'),
    salesEmail: env('CREDENTIALS__TENANT_17G5__SUPPORT__SALES_EMAIL'),
    supportPhoneNumber: env('CREDENTIALS__TENANT_17G5__SUPPORT__PHONE'),
    supportChatId: env('FRONT_APP__CHAT_ID_TENANT_17G5'),
    conferencePhoneNumber: env('CREDENTIALS__TENANT_17G5__SUPPORT__CONFERENCE_PHONE'),
    api: {
      internal: env('TENANT_17G5_WS__HOSTNAME_INTERNAL'),
    },
    ga: {
      trackingId: env('GA__TRACKING_ID_TENANT_17G5'),
    },
    gtm: {
      trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_17G5__GTM_ID'),
    },
    featureToggle: {
      diligenceChecklistEnabled: { cookieName: 'diligenceChecklistEnabled' },
      documentTranslationEnabled: { cookieName: 'documentTranslationEnabled' },
      askMeEnabled: { cookieName: 'askMeEnabled' },
      ocrEnabled: { cookieName: 'ocrEnabled' },
      videoPlayerEnabled: { cookieName: 'videoPlayerEnabled' },
    },
    options: {
      isDataroom: true,
      tenantPathName: 'dataroom',
      isCountryOfBusinessEnabled: false,
      isGeneralAppDisclaimerEnabled: false,
      isAnalyticsViewTimeEnabled: false,
      isVisibilityControlEnabled: false,
      tenantUrlPrefix: env('TENANT_17G5___DATAROOM__PREFIX_URL'),
      defaultPhoneCountry: 'us',
      tenantLabelLg: '17g5 data room',
      tenantLabel: 'Data Room',
      tenantLabelSm: 'data room',
      label: 'Data Room',
      isDocumentationStateEnabled: false,
      isStagingModuleAvailable: true,
      isDocumentTranslationEnabled: true,
      isFileStorageRegionSelectEnabled: false,
      isStagesEnabled: false,
      isInitialTimeZoneEnabled: false,
      isInvestorPermissions: false,
      isRestrictionByCountryEnabled: false,
      isEnhancedTaggingSectionRequired: false,
      isTransactionTypeEnabled: false,
      isPublicListingOptionEnabled: false,
      isHelpSiteEnabled: true,
      isManageAccessRequestsEnabled: false,
      tenantLabelPlural: 'Data Rooms',
      tenantSettingsPrefix: 'data-room-settings',
      visibleSectorForTransactionTypeList: [],
    },
    isConsentForEDeliveryRequired: false,
    isSectorAlwaysVisible: true,
  },
  investorset: {
    code: 'investorset' as const,
    name: 'InvestorSet',
    abbr: 'INV',
    hostname: env('INVESTORSET_DOMAIN'),
    supportEmail: env('CREDENTIALS__TENANT_INVESTORSET__SUPPORT__EMAIL'),
    salesEmail: env('CREDENTIALS__TENANT_INVESTORSET__SUPPORT__SALES_EMAIL'),
    supportPhoneNumber: env('CREDENTIALS__TENANT_INVESTORSET__SUPPORT__PHONE'),
    supportChatId: env('FRONT_APP__CHAT_ID_TENANT_INVESTORSET'),
    conferencePhoneNumber: env('CREDENTIALS__TENANT_INVESTORSET__SUPPORT__CONFERENCE_PHONE'),
    api: {
      internal: env('TENANT_INVESTORSET_WS__HOSTNAME_INTERNAL'),
    },
    ga: {
      trackingId: env('GA__TRACKING_ID_TENANT_INVESTORSET'),
    },
    gtm: {
      trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_INVESTORSET__GTM_ID'),
    },
    featureToggle: {
      diligenceChecklistEnabled: { cookieName: 'diligenceChecklistEnabled' },
      documentTranslationEnabled: { cookieName: 'documentTranslationEnabled' },
      askMeEnabled: { cookieName: 'askMeEnabled' },
      ocrEnabled: { cookieName: 'ocrEnabled' },
      videoPlayerEnabled: { cookieName: 'videoPlayerEnabled' },
    },
    options: {
      isDataroom: true,
      tenantPathName: 'investorset',
      isCountryOfBusinessEnabled: false,
      isGeneralAppDisclaimerEnabled: false,
      isAnalyticsViewTimeEnabled: false,
      isVisibilityControlEnabled: false,
      tenantUrlPrefix: env('TENANT_INVESTORSET___DATAROOM__PREFIX_URL'),
      defaultPhoneCountry: 'us',
      tenantLabelLg: 'InvestorSet',
      tenantLabel: 'InvestorSet',
      tenantLabelSm: 'InvestorSet',
      label: 'InvestorSet',
      isDocumentationStateEnabled: false,
      isStagingModuleAvailable: true,
      isDocumentTranslationEnabled: false,
      isFileStorageRegionSelectEnabled: true,
      isStagesEnabled: false,
      isInitialTimeZoneEnabled: false,
      isInvestorPermissions: false,
      isRestrictionByCountryEnabled: false,
      isEnhancedTaggingSectionRequired: true,
      isTransactionTypeEnabled: true,
      isPublicListingOptionEnabled: true,
      isHelpSiteEnabled: true,
      isManageAccessRequestsEnabled: true,
      tenantLabelPlural: 'InvestorSets',
      tenantSettingsPrefix: 'investorset-settings',
      visibleSectorForTransactionTypeList: [
        '1a0c0874-21dd-48f8-9288-6c7c103ed1e0', // ASSET-BACKED SECURITY
      ],
    },
    isConsentForEDeliveryRequired: false,
    isSectorAlwaysVisible: false,
  },
  verisend: {
    code: 'verisend' as const,
    name: 'VeriSend',
    abbr: 'VRS',
    hostname: env('VERISEND_DOMAIN'),
    supportEmail: env('CREDENTIALS__TENANT_VERISEND__SUPPORT__EMAIL'),
    salesEmail: env('CREDENTIALS__TENANT_VERISEND__SUPPORT__SALES_EMAIL'),
    supportPhoneNumber: env('CREDENTIALS__TENANT_VERISEND__SUPPORT__PHONE'),
    supportChatId: env('FRONT_APP__CHAT_ID_TENANT_VERISEND'),
    conferencePhoneNumber: null,
    api: {
      internal: env('TENANT_VERISEND_WS__HOSTNAME_INTERNAL'),
    },
    ga: {
      trackingId: env('GA__TRACKING_ID_TENANT_VERISEND'),
    },
    gtm: {
      trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_VERISEND__GTM_ID'),
    },
    featureToggle: {
      diligenceChecklistEnabled: { cookieName: 'diligenceChecklistEnabled' },
      documentTranslationEnabled: { cookieName: 'documentTranslationEnabled' },
      askMeEnabled: { cookieName: 'askMeEnabled' },
      ocrEnabled: { cookieName: 'ocrEnabled' },
      videoPlayerEnabled: { cookieName: 'videoPlayerEnabled' },
    },
    options: {
      isDataroom: true,
      tenantPathName: 'verisend',
      isCountryOfBusinessEnabled: false,
      isGeneralAppDisclaimerEnabled: false,
      defaultPhoneCountry: 'us',
      isAnalyticsViewTimeEnabled: false,
      isVisibilityControlEnabled: false,
      tenantUrlPrefix: env('TENANT_VERISEND___DATAROOM__PREFIX_URL'),
      tenantLabelLg: 'VeriSend',
      tenantLabel: 'VeriSend',
      tenantLabelSm: 'VeriSend',
      label: 'VeriSend',
      isDocumentationStateEnabled: true,
      isStagingModuleAvailable: false,
      isDocumentTranslationEnabled: false,
      isFileStorageRegionSelectEnabled: true,
      isStagesEnabled: false,
      isInitialTimeZoneEnabled: false,
      isInvestorPermissions: false,
      isRestrictionByCountryEnabled: false,
      isEnhancedTaggingSectionRequired: true,
      isTransactionTypeEnabled: true,
      isPublicListingOptionEnabled: true,
      isHelpSiteEnabled: true,
      isManageAccessRequestsEnabled: true,
      tenantLabelPlural: 'VeriSends',
      tenantSettingsPrefix: 'verisend-settings',
      visibleSectorForTransactionTypeList: [
        'f333a22e-ed64-4ebb-b261-9ff8010face4', // ASSET-BACKED SECURITY
      ],
    },
    isConsentForEDeliveryRequired: true,
    isSectorAlwaysVisible: false,
  },
  researchroom: {
    code: 'researchroom' as const,
    name: 'ResearchRoom',
    abbr: 'RSR',
    hostname: env('RESEARCHROOM_DOMAIN'),
    supportEmail: env('CREDENTIALS__TENANT_RESEARCHROOM__SUPPORT__EMAIL'),
    salesEmail: env('CREDENTIALS__TENANT_RESEARCHROOM__SUPPORT__SALES_EMAIL'),
    supportPhoneNumber: env('CREDENTIALS__TENANT_RESEARCHROOM__SUPPORT__PHONE'),
    supportChatId: env('FRONT_APP__CHAT_ID_TENANT_RESEARCHROOM'),
    conferencePhoneNumber: null,
    api: {
      internal: env('TENANT_RESEARCHROOM_WS__HOSTNAME_INTERNAL'),
    },
    ga: {
      trackingId: env('GA__TRACKING_ID_TENANT_RESEARCHROOM'),
    },
    gtm: {
      trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_RESEARCHROOM__GTM_ID'),
    },
    featureToggle: {
      diligenceChecklistEnabled: { cookieName: 'diligenceChecklistEnabled' },
      documentTranslationEnabled: { cookieName: 'documentTranslationEnabled' },
      ocrEnabled: { cookieName: 'ocrEnabled' },
      askMeEnabled: { cookieName: 'askMeEnabled' },
      videoPlayerEnabled: { cookieName: 'videoPlayerEnabled' },
    },
    options: {
      isDataroom: true,
      tenantPathName: 'researchroom',
      isCountryOfBusinessEnabled: true,
      isGeneralAppDisclaimerEnabled: true,
      defaultPhoneCountry: 'gb',
      tenantUrlPrefix: env('TENANT_RESEARCHROOM___DATAROOM__PREFIX_URL'),
      tenantLabelLg: 'ResearchRoom',
      tenantLabel: 'ResearchRoom',
      tenantLabelSm: 'Research',
      label: 'Research',
      isDocumentationStateEnabled: false,
      isStagingModuleAvailable: false,
      isDocumentTranslationEnabled: false,
      isFileStorageRegionSelectEnabled: false,
      isStagesEnabled: true,
      isInitialTimeZoneEnabled: true,
      isInvestorPermissions: true,
      isRestrictionByCountryEnabled: true,
      isVisibilityControlEnabled: false,
      isEnhancedTaggingSectionRequired: true,
      isTransactionTypeEnabled: false,
      isPublicListingOptionEnabled: true,
      isHelpSiteEnabled: false,
      isAnalyticsViewTimeEnabled: false,
      isManageAccessRequestsEnabled: true,
      tenantLabelPlural: 'Research',
      tenantSettingsPrefix: 'researchroom-settings',
      visibleSectorForTransactionTypeList: [
        'f333a22e-ed64-4ebb-b261-9ff8010face4', // ASSET-BACKED SECURITY
      ],
    },
    isConsentForEDeliveryRequired: true,
    isSectorAlwaysVisible: false,
  },
};
